export const generalIconsList = {
  arrows: {
    url: '/static/images/global/icons/arrows.svg',
    alt: 'arrows icon',
    width: 44,
    height: 44
  },
  logisticsBox: {
    url: '/static/images/global/icons/logistics-box.svg',
    alt: 'logistics box icon',
    width: 44,
    height: 44
  },
  financialServicesCard: {
    url: '/static/images/global/icons/financial-services-card.svg',
    alt: 'financial services icon',
    width: 44,
    height: 44
  },
  healthInsuranceCard: {
    url: '/static/images/global/icons/health-insurance-card.svg',
    alt: 'health insurance icon',
    width: 44,
    height: 44
  },
  award: {
    url: '/static/images/global/icons/award.svg',
    alt: 'award icon',
    width: 44,
    height: 44
  },
  browser: {
    url: '/static/images/global/icons/browser-window.svg',
    alt: 'browser icon',
    width: 44,
    height: 44
  },
  circle: {
    url: '/static/images/global/icons/circle-star.svg',
    alt: 'circle icon',
    width: 44,
    height: 44
  },
  circles: {
    url: '/static/images/global/icons/circles.svg',
    alt: 'circles icon',
    width: 44,
    height: 44
  },
  clipboard: {
    url: '/static/images/global/icons/clipboard.svg',
    alt: 'clipboard icon',
    width: 44,
    height: 44
  },
  clipboardDark: {
    url: '/static/images/global/icons/clipboard-dark.svg',
    alt: 'clipboard icon',
    width: 44,
    height: 44
  },
  clockCheck: {
    url: '/static/images/global/icons/clock-check.svg',
    alt: 'clockCheck icon',
    width: 44,
    height: 44
  },
  clock: {
    url: '/static/images/global/icons/clock.svg',
    alt: 'clock icon',
    width: 44,
    height: 44
  },
  cycle: {
    url: '/static/images/global/icons/cycle.svg',
    alt: 'cycle icon',
    width: 44,
    height: 44
  },
  data: {
    url: '/static/images/global/icons/data-dots.svg',
    alt: 'data icon',
    width: 44,
    height: 44
  },
  document: {
    url: '/static/images/global/icons/document-search.svg',
    alt: 'document ai icon',
    width: 44,
    height: 44
  },
  efficiency: {
    url: '/static/images/global/icons/efficiency.svg',
    alt: 'efficiency icon',
    width: 44,
    height: 44
  },
  flexibility: {
    url: '/static/images/global/icons/flexibility.svg',
    alt: 'flexibility icon',
    width: 44,
    height: 44
  },
  gauge: {
    url: '/static/images/global/icons/gauge.svg',
    alt: 'gauge icon',
    width: 44,
    height: 44
  },
  graph: {
    url: '/static/images/global/icons/graph-wrench.svg',
    alt: 'graph icon',
    width: 44,
    height: 44
  },
  hexagon: {
    url: '/static/images/global/icons/hexagon.svg',
    alt: 'hexagon icon',
    width: 44,
    height: 44
  },
  infinity: {
    url: '/static/images/global/icons/infinity.svg',
    alt: 'infinity icon',
    width: 44,
    height: 44
  },
  labels: {
    url: '/static/images/global/icons/labels.svg',
    alt: 'labels icon',
    width: 44,
    height: 44
  },
  money: {
    url: '/static/images/global/icons/money.svg',
    alt: 'money icon',
    width: 44,
    height: 44
  },
  personPlus: {
    url: '/static/images/global/icons/person-plus.svg',
    alt: 'personPlus icon',
    width: 44,
    height: 44
  },
  person: {
    url: '/static/images/global/icons/person.svg',
    alt: 'person icon',
    width: 44,
    height: 44
  },
  phone: {
    url: '/static/images/global/icons/phone.svg',
    alt: 'phone icon',
    width: 44,
    height: 44
  },
  pulse: {
    url: '/static/images/global/icons/pulse.svg',
    alt: 'pulse icon',
    width: 44,
    height: 44
  },
  sensors: {
    url: '/static/images/global/icons/sensors.svg',
    alt: 'sensors icon',
    width: 44,
    height: 44
  },
  shield: {
    url: '/static/images/global/icons/shield.svg',
    alt: 'shield icon',
    width: 44,
    height: 44
  },
  target: {
    url: '/static/images/global/icons/target.svg',
    alt: 'target icon',
    width: 44,
    height: 44
  },
  technology: {
    url: '/static/images/global/icons/technology-enabled.svg',
    alt: 'technology icon',
    width: 44,
    height: 44
  },
  trefoil: {
    url: '/static/images/global/icons/trefoil.svg',
    alt: 'trefoil icon',
    width: 44,
    height: 44
  },
  textClassification: {
    src: '/static/images/global/icons/text-classification.svg',
    alt: 'classification icon',
    width: 24,
    height: 24
  },
  textNamedEntityRecognition: {
    src: '/static/images/global/icons/text-named-entity-recognition.svg',
    alt: 'named entity recognition icon',
    width: 24,
    height: 24
  },
  textGeneration: {
    src: '/static/images/global/icons/text-generation.svg',
    alt: 'generation icon',
    width: 24,
    height: 24
  },
  textTranscription: {
    src: '/static/images/global/icons/text-transcription.svg',
    alt: 'transctiption icon',
    width: 24,
    height: 24
  },
  textRLHF: {
    src: '/static/images/global/icons/text-rlhf.svg',
    alt: 'rlhf icon',
    width: 24,
    height: 24
  },
  textComparison: {
    src: '/static/images/global/icons/text-comparison.svg',
    alt: 'comparison icon',
    width: 24,
    height: 24
  },
  textPromptResponsePairs: {
    src: '/static/images/global/icons/text-prompt-response-pairs.svg',
    alt: 'prompt-response-pairs icon',
    width: 24,
    height: 24
  },
  audioClassification: {
    src: '/static/images/global/icons/audio-classification.svg',
    alt: 'classification icon',
    width: 24,
    height: 24
  },
  audioTranscription: {
    src: '/static/images/global/icons/audio-transcription.svg',
    alt: 'transctiption icon',
    width: 24,
    height: 24
  },
  '3dSensorFusionCuboid': {
    src: '/static/images/global/icons/3d-sensor-fusion-cuboid.svg',
    alt: 'cuboid icon',
    width: 24,
    height: 24
  },
  '3dSensorFusionSegmentation': {
    src: '/static/images/global/icons/3d-segmentation.svg',
    alt: 'segmentation icon',
    width: 24,
    height: 24
  },
  videoBoundingBox: {
    src: '/static/images/global/icons/video-bounding-box.svg',
    alt: 'bounding box icon',
    width: 24,
    height: 24
  },
  videoClassification: {
    src: '/static/images/global/icons/video-classification.svg',
    alt: 'classification icon',
    width: 24,
    height: 24
  },
  videoCuboid: {
    src: '/static/images/global/icons/video-cuboid.svg',
    alt: 'cuboid icon',
    width: 24,
    height: 24
  },
  videoMultiGeometry: {
    src: '/static/images/global/icons/video-multi-geometry.svg',
    alt: 'multi geometry icon',
    width: 24,
    height: 24
  },
  videoLinesAndSplines: {
    src: '/static/images/global/icons/video-lines-and-splines.svg',
    alt: 'lines and splines icon',
    width: 24,
    height: 24
  },
  videoPoint: {
    src: '/static/images/global/icons/video-point.svg',
    alt: 'point icon',
    width: 24,
    height: 24
  },
  videoPolygon: {
    src: '/static/images/global/icons/video-polygon.svg',
    alt: 'polygon icon',
    width: 24,
    height: 24
  },
  videoSemanticSegmentation: {
    src: '/static/images/global/icons/video-semantic-segmentation.svg',
    alt: 'semantic segmentation icon',
    width: 24,
    height: 24
  },
  imageBoundingBox: {
    src: '/static/images/global/icons/image-bounding-box.svg',
    alt: 'bounding box icon',
    width: 24,
    height: 24
  },
  imageClassification: {
    src: '/static/images/global/icons/image-classification.svg',
    alt: 'classification icon',
    width: 24,
    height: 24
  },
  imageCuboid: {
    src: '/static/images/global/icons/image-cuboid.svg',
    alt: 'cuboid icon',
    width: 24,
    height: 24
  },
  imageMultiGeometry: {
    src: '/static/images/global/icons/image-multi-geometry.svg',
    alt: 'multi geometry icon',
    width: 24,
    height: 24
  },
  imageLinesAndSplines: {
    src: '/static/images/global/icons/image-lines-and-splines.svg',
    alt: 'lines and splines icon',
    width: 24,
    height: 24
  },
  imagePoint: {
    src: '/static/images/global/icons/image-point.svg',
    alt: 'point icon',
    width: 24,
    height: 24
  },
  imagePolygon: {
    src: '/static/images/global/icons/image-polygon.svg',
    alt: 'polygon icon',
    width: 24,
    height: 24
  },
  imageSemanticSegmentation: {
    src: '/static/images/global/icons/image-semantic-segmentation.svg',
    alt: 'semantic segmentation icon',
    width: 24,
    height: 24
  },
  ranking: {
    src: '/static/images/global/icons/ranking.svg',
    alt: 'ranking icon',
    width: 24,
    height: 24
  },
  rating: {
    src: '/static/images/global/icons/rating.svg',
    alt: 'rating icon',
    width: 24,
    height: 24
  },
  mappingVectors: {
    src: '/static/images/global/icons/mapping-vectors.svg',
    alt: 'mapping vectors icon',
    width: 24,
    height: 24
  },
  mappingSemantic: {
    src: '/static/images/global/icons/mapping-semantic.svg',
    alt: 'mapping semantic icon',
    width: 24,
    height: 24
  }
};
